import Glide from '@glidejs/glide'; // tslint:disable-line
import {Breakpoints} from '@glidejs/glide/dist/glide.modular.esm'; // tslint:disable-line

window.addEventListener("load", () => {
  const sliders = document.querySelectorAll('.js-featured-slider');

  if (!sliders) return;

  sliders.forEach((slider) => {
    new Glide(`#${slider.id}.glide`, {
      breakpoints: {
        480: {
          gap: 2,
          perView: 1,
        },
        1024: {
          gap: 12,
          perView: 2,
        },
        1280: {
          perView: 4,
        },
      },
      gap: 22,
      perView: 4,
      rewind: true,
      type: 'slider',
    }).mount({Breakpoints});
  });
});
